import React from 'react';
import { DeliveryDetail } from '../callCenterDeliveryIssuesTypes';
import styles from './DeliveryDetailCard.module.css';

interface DeliveryDetailCardProps {
  detail: DeliveryDetail;
}

export const DeliveryDetailCard: React.FC<DeliveryDetailCardProps> = ({ detail }) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Delivery Detail — {detail.deliveryId}</h3>
      <div className={styles.body}>
        <div className={styles.timelineCol}>
          <h4 className={styles.subhead}>Delivery Timeline</h4>
          <ul className={styles.timeline}>
            {detail.timeline.map((entry, idx) => (
              <li key={entry.id} className={styles.entry}>
                <span className={`${styles.dot} ${styles[`dot_${entry.dot}`]}`} />
                {idx < detail.timeline.length - 1 && <span className={styles.line} />}
                <div className={styles.entryContent}>
                  <p className={styles.entryTitle}>{entry.title}</p>
                  <p className={styles.entryMeta}>{entry.meta}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.proofCol}>
          <h4 className={styles.subhead}>Proof of Delivery</h4>
          <div className={styles.uploadBox}>
            <span className={styles.uploadIcon}>
              <svg viewBox="0 0 24 24" fill="currentColor" width="28" height="28">
                <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" />
              </svg>
            </span>
            <p className={styles.uploadHint}>No photo uploaded · Click to request</p>
          </div>

          <h4 className={styles.subhead}>Driver Notes</h4>
          <p className={styles.notes}>{detail.driverNotes}</p>
        </div>
      </div>
    </div>
  );
};
